import type { ITypeSuite } from "ts-interface-checker";
import { iface, indexKey, opt } from "ts-interface-checker";

const Channel = iface([], {
  displayName: opt("string"),
  functionID: opt("string"),
  room: opt("string"),
  floor: opt("string"),
  inputs: opt(
    iface([], {
      [indexKey]: "InOutPut",
    })
  ),
  outputs: opt(
    iface([], {
      [indexKey]: "InOutPut",
    })
  ),
  parameters: opt(
    iface([], {
      [indexKey]: "string",
    })
  ),
  type: opt("string"),
});

export const ChannelTypeSuite: ITypeSuite = {
  Channel,
};
